import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/icon-folder.svg';
const IconFolder = () => React.createElement(IconSvg, null);
export default IconFolder;
